import type {
  PackedItemsFunnelStats,
  PackedItemsOverviewResponse,
} from '@/shared/hooks/api/packedItemsOverview'
import { distributePercents } from './statPercentDistribution'

export type { PackedItemsFunnelStats }

export type FlatPackedItemRow = PackedItemsOverviewResponse['items'][number]

export type PackedItemsTabStats = {
  packedItems: PackedItemsFunnelStats
}

export function derivePackedItemsTabStatsFromStats(
  stats: PackedItemsFunnelStats | undefined
): PackedItemsTabStats {
  if (stats == null) {
    return {
      packedItems: {
        total: 0,
        unaddressed: 0,
        unaddressedPercent: 0,
        inProgress: 0,
        inProgressPercent: 0,
        completed: 0,
        completedPercent: 0,
      },
    }
  }

  return {
    packedItems: stats,
  }
}

export type PackedItemPackagingSummary = {
  completedAt?: string | null
}

export function derivePackedItemComplianceProgressFromPackagingItems(
  packagingItems: PackedItemPackagingSummary[]
): FlatPackedItemRow['complianceProgress'] {
  if (packagingItems.length === 0) {
    return 'NO_ITEMS'
  }
  if (packagingItems.every((item) => item.completedAt != null)) {
    return 'ALL_ITEMS_COMPLETE'
  }
  return 'DRAFT_ITEMS'
}

export function derivePackedItemsFunnelStatsFromItems(
  items: Array<{
    hasNoPackaging?: boolean
    packagingItems: PackedItemPackagingSummary[]
  }>
): PackedItemsFunnelStats {
  let unaddressed = 0
  let inProgress = 0
  let completed = 0

  for (const item of items) {
    const complianceProgress =
      derivePackedItemComplianceProgressFromPackagingItems(item.packagingItems)
    if (complianceProgress === 'NO_ITEMS' && item.hasNoPackaging === true) {
      completed += 1
    } else if (complianceProgress === 'NO_ITEMS') {
      unaddressed += 1
    } else if (complianceProgress === 'ALL_ITEMS_COMPLETE') {
      completed += 1
    } else {
      inProgress += 1
    }
  }

  const total = items.length
  const [
    unaddressedPercent,
    inProgressPercent,
    completedPercent,
  ] = distributePercents([unaddressed, inProgress, completed], total)

  return {
    total,
    unaddressed,
    unaddressedPercent,
    inProgress,
    inProgressPercent,
    completed,
    completedPercent,
  }
}
